import {getIsActiveLink, mapLinkToListItem} from '@pluto/sidebar-list-item';

export const LINKS = [];

export default function AppSidebarCommonLinks({path}: any): any {
    const withPath = getIsActiveLink(path);
    
    return LINKS.map(mapLinkToListItem(withPath) as any);
}
